import React, { useState, useEffect, Fragment } from "react"
import useStyles from "./styles"
import { Box, TextField, Typography, FormHelperText } from "@material-ui/core"
import PropTypes from "prop-types"
import SaveButton from "./SaveButton/index"
import CharacterCounter from "../CharacterCounter/index"

const NoteBox = ({
  setNoteVal = () => {},
  noteVal = "",
  isDisabled = false,
  maxLength = 1000,
  shootId = null,
  isSolo = false,
  ...props
}) => {
  const classes = useStyles()
  const [inputError, setInputError] = useState(false)
  const handleChange = e => {
    setNoteVal(e.target.value)
  }
  //every time note val changes check if greater than maxLength if it is setInputError to true

  useEffect(
    () => {
      if (noteVal.length > maxLength) {
        setInputError(true)
      }
      if (noteVal.length <= maxLength) {
        setInputError(false)
      }
    },
    [noteVal]
  )

  const headerText = props.match.params.short_code
    ? "Note from Crew Mama"
    : "Message"

  return (
    <div className={classes.inputContainer}>
      <Box display="flex" justifyContent="space-between" />
      <Box display="flex" justifyContent={"space-between"}>
        <Box ml={1}>
          <Typography className={classes.headerText}>{headerText} </Typography>
        </Box>
        {!isDisabled && (
          <Box mr={1}>
            <CharacterCounter
              typingLength={noteVal.length}
              maxLength={maxLength}
            />
          </Box>
        )}
      </Box>
      <TextField
        id="note-box"
        multiline
        placeholder={isDisabled ? "No message" : "Add a message (optional)"}
        error={inputError}
        value={noteVal}
        onChange={handleChange}
        className={classes.root}
        margin="dense"
        variant="outlined"
        disabled={isDisabled}
        rows={8}
        rowsMax={12}
        InputProps={{
          classes: {
            root: classes.inputRoot,
          },
        }}
      />
      <FormHelperText className={classes.FormHelperText} error={inputError}>
        {inputError ? `Note must be less than ${maxLength} characters` : ""}
      </FormHelperText>
      <Box display="flex" justifyContent="space-between">
        {!isDisabled && (
          <Fragment>
            <Box ml={1} />
            <Box mr={1}>
              {!isSolo && (
                <SaveButton
                  noteVal={noteVal}
                  inputError={inputError}
                  shootId={shootId}
                />
              )}
            </Box>
          </Fragment>
        )}
      </Box>
    </div>
  )
}
export default NoteBox

NoteBox.propTypes = {
  setNoteVal: PropTypes.func,
  noteVal: PropTypes.string,
  isDisabled: PropTypes.bool,
  maxLength: PropTypes.number,
  shootId: PropTypes.number,
  isSolo: PropTypes.bool,
}
